import React, { useEffect, useState } from 'react'
import { Card, CardBody, Col, Input, Label, Row, Tooltip } from 'reactstrap'
import CustomDate from '../../../../components/customDate/CustomDate'
import '@styles/react/libs/flatpickr/flatpickr.scss'
import { useTranslation } from 'react-i18next'

import CustomSearchSelect from '../../../../components/customSearchSelect/customSearchSelect'
import { useDispatch, useSelector } from 'react-redux'
import { SelectServiceTypes } from '../../../../../redux/searchServices/types'
import moment from 'moment'
import { RqErrorMessage } from '../../../../../helpers/RequiredMessage'
import CheckboxBasic from '../../../../components/customCheckbox/CheckboxBasic'
import SelectOptions from '../../../../components/Select/SelectOptions'
import { interest_rate_items } from '../../../../../utility/selectItems/selectItems'
import { AiFillInfoCircle } from 'react-icons/ai'

const DebtDetails = ({
  setFieldValue,
  values,
  handleSubmit,
  errors,
  touched,
  handleChange,
}) => {
  const { t } = useTranslation()
  const defaultTypes = useSelector((state) => state.SearchSelectSlice.types)
  const [buildings, setBuildings] = useState([])
  const typesSearchKey = useSelector((state) => state.SearchSelectSlice.typeKey)
  const defaultBuilding = useSelector(
    (state) => state.SearchSelectSlice.buildings
  )
  const buildingKey = useSelector(
    (state) => state.SearchSelectSlice.buildingKey
  )
  const [tooltipOpen, setTooltipOpen] = useState(false)

  const toggle = () => {
    setTooltipOpen(!tooltipOpen)
  }
  const [tooltipOpenFirst, setTooltipOpenFirst] = useState(false)

  const toggleFirst = () => {
    setTooltipOpenFirst(!tooltipOpenFirst)
  }
  useEffect(() => {
    setFieldValue('buildings', buildings)
  }, [buildings])

  return (
    <Col
      tag="form"
      onSubmit={handleSubmit}
      md={3}
      style={{
        display: ' block',
        animation: 'fadein 1s',
      }}
    >
      <Card>
        <CardBody
          style={{ paddingBottom: values.is_interest ? '170px' : null }}
        >
          <div className="d-flex justify-content-around my-2 pt-35">
            <h4>{t('Borç Detayları')}</h4>
          </div>
          <hr></hr>
          <Label className="form-label" for="lastNameMulti">
            {t('Bina')}
          </Label>
          <CustomSearchSelect
            defaultValues={defaultBuilding}
            keyValues={buildingKey}
            defaultDispatch={{
              type: SelectServiceTypes.SHOW_SEARCH_BUILDING,
            }}
            searchType={SelectServiceTypes.SHOW_SEARCH_BUILDING_KEY}
            defaultValue={values.buildings}
            value={buildings}
            setValueState={setBuildings}
            isMulti={true}
          />
          {RqErrorMessage(errors.buildings, touched.buildings)}
          <CustomSearchSelect
            label={t('Muhasabe Türü')}
            keyValues={typesSearchKey}
            defaultValues={defaultTypes}
            defaultDispatch={{
              type: SelectServiceTypes.SHOW_SEARCH_TYPE,
              payload: { type: 3 },
            }}
            searchType={SelectServiceTypes.SHOW_SEARCH_TYPE_KEY}
            searchPayload={3}
            name="accounting_type_id"
            selectLabel={'accounting_type_label'}
            setFieldValue={setFieldValue}
            type={values.type}
            value={{
              id: values.accounting_type_id,
              name: values.accounting_type_label,
            }}
          />
          {RqErrorMessage(
            errors.accounting_type_id,
            touched.accounting_type_id
          )}

          <Label className="form-label" for="description">
            {t('Açıklama')}
          </Label>
          <Input
            type="text"
            name="description"
            id="description"
            placeholder="Description"
            onChange={handleChange}
            value={values.description}
          />
          {RqErrorMessage(errors.description, touched.description)}

          <Label className="form-label" for="description">
            {t('Tutar')}
          </Label>
          <Input
            autocomplete="off"
            type="text"
            name="amount"
            id="amount"
            placeholder="0"
            onChange={handleChange}
            value={values.amount}
          />
          {RqErrorMessage(errors.amount, touched.amount)}

          <Col xs={12} className="pt-2">
            <div
              className="d-flex flex-wrap mb-2 cursor-pointer"
              style={{ flexDirection: 'row', position: 'relative' }}
              onClick={() => {
                setFieldValue('amountType', 1)
              }}
            >
              <Row>
                <Col xs="1">
                  <CheckboxBasic
                    onChange={(e) => {
                      if (e.target.checked === true) {
                        setFieldValue('amountType', 1)
                      } else {
                        setFieldValue('amountType', 2)
                      }
                    }}
                    checked={values.amountType === 1 ? true : false}
                  />
                </Col>
                <Col xs="10">
                  <div
                    title={t('Hesaplanan Tutarı Tam Yuvarla')}
                    style={{
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      if (values.amountType === 2) {
                        setFieldValue('amountType', 1)
                      } else {
                        setFieldValue('amountType', 2)
                      }
                    }}
                  >
                    {t('Hesaplanan Tutarı Tam Yuvarla')}
                  </div>
                </Col>
                <div
                  style={{
                    width: '0px',
                    position: 'absolute',
                    right: '0px',
                    top: '-2px',
                    backgroundColor: 'white',
                    cursor: 'pointer',
                  }}
                >
                  <AiFillInfoCircle id="TooltipFirst" size={20} />
                </div>
                <Tooltip
                  isOpen={tooltipOpenFirst}
                  placement="right"
                  target="TooltipFirst"
                  style={{
                    backgroundColor: 'white',
                    color: 'black',
                    boxShadow: '0 3px 10px rgb(0 0 0 / 0.2)',
                    padding: '15px 10px',
                  }}
                  toggle={toggleFirst}
                >
                  {t(
                    'Örnek olarak 55.45 ~ 55 veya 55.65 ~ 56 olarak alınacaktır.'
                  )}
                </Tooltip>
              </Row>
            </div>
            <div
              className="d-flex mb-2 cursor-pointer"
              style={{ flexDirection: 'row', position: 'relative' }}
              onClick={() => {
                setFieldValue('amountType', 2)
              }}
            >
              <Row>
                <Col xs="1">
                  <CheckboxBasic
                    onChange={(e) => {
                      if (e.target.checked === true) {
                        setFieldValue('amountType', 2)
                      } else {
                        setFieldValue('amountType', 1)
                      }
                    }}
                    checked={values.amountType === 2 ? true : false}
                  />
                </Col>
                <Col xs="10">
                  <div
                    title={t('Hesaplanan Tutarı Ondalık Yuvarla')}
                    style={{
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      if (values.amountType === 1) {
                        setFieldValue('amountType', 2)
                      } else {
                        setFieldValue('amountType', 1)
                      }
                    }}
                  >
                    {t('Hesaplanan Tutarı Ondalık Yuvarla')}
                  </div>
                </Col>
                <div
                  style={{
                    width: '0px',
                    position: 'absolute',
                    right: '0px',
                    top: '-2px',
                    backgroundColor: 'white',
                    cursor: 'pointer',
                  }}
                >
                  <AiFillInfoCircle id="Tooltip" size={20} />
                </div>
                <Tooltip
                  isOpen={tooltipOpen}
                  placement="right"
                  target="Tooltip"
                  style={{
                    backgroundColor: 'white',
                    color: 'black',
                    boxShadow: '0 3px 10px rgb(0 0 0 / 0.2)',
                    padding: '15px 10px',
                  }}
                  toggle={toggle}
                >
                  {t(
                    'Örnek olarak 55.554 ~ 55.55 veya 55.556 ~ 55.56 olarak alınacaktır.'
                  )}
                </Tooltip>
              </Row>
            </div>
          </Col>
          <CustomDate
            name="due_date"
            label={t('Start Date')}
            value={values.due_date}
            onChange={(e) =>
              setFieldValue('due_date', moment(e[0]).format('DD.MM.YYYY'))
            }
          />
          {RqErrorMessage(errors.due_date, touched.due_date)}
          <CustomDate
            name="last_interest"
            label={t('Last Date')}
            value={values.last_interest}
            onChange={(e) =>
              setFieldValue('last_interest', moment(e[0]).format('DD.MM.YYYY'))
            }
          />
          {RqErrorMessage(errors.last_interest, touched.last_interest)}
          <Col xs={12} className="pt-2">
            <div
              className="d-flex flex-wrap mb-1 "
              style={{ cursor: 'pointer' }}
              onClick={() => setFieldValue('is_interest', !values.is_interest)}
            >
              <CheckboxBasic checked={values.is_interest} />{' '}
              <small>{t('Gecikme Tazminatı Uygula')}</small>
            </div>
            {RqErrorMessage(errors.is_interest, touched.is_interest)}
          </Col>

          {values.is_interest ? (
            <>
              <CustomDate
                name="interest_date"
                label={t('Gecikme Tazminatı Başlangıç Tarihi')}
                value={values.interest_date}
                onChange={(e) =>
                  setFieldValue(
                    'interest_date',
                    moment(e[0]).format('DD.MM.YYYY')
                  )
                }
              />
              {RqErrorMessage(errors.interest_date, touched.interest_date)}
              <Label className="form-label small_label" for="description">
                {t('Gecikme Tazminat Yüzdesi')}
              </Label>
              <Input
                type="text"
                name="interest_rate"
                id="interest_rate"
                placeholder="0"
                onChange={handleChange}
                value={values.interest_rate}
              />
              {RqErrorMessage(errors.interest_rate, touched.interest_rate)}
              <Label className="form-label small_label" for="lastNameMulti">
                {t('Tazminat Uygulanma Şekli')}
              </Label>
              <SelectOptions
                options={interest_rate_items}
                defaultValue={interest_rate_items[0]}
                onChange={(e) => setFieldValue('interest_type', e.id)}
              />
              {RqErrorMessage(errors.interest_type, touched.interest_type)}
            </>
          ) : null}
        </CardBody>
      </Card>
    </Col>
  )
}

export default DebtDetails
